export const formatNumbers = (number, enforceFormatting = false) => {
    if (number === null || number === undefined || number === "") return "";
  
    const num = Number(number);
  
    if (!enforceFormatting && Number.isInteger(num)) {
      return num.toLocaleString("en-US"); // commas only
    }
  
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  export const formatNumbers0 = (number) => {
    if (number === null || number === undefined || number === "") return "";
  
    const num = Number(number);
  
    // Round to whole number and add commas
    return Math.round(num).toLocaleString("en-US");
  }